import { Component, OnInit } from "@angular/core";
import { ProjectConstants } from "../project-constants";

@Component({
  selector: "app-archive",
  templateUrl: "./archive.component.html",
  styleUrls: ["./archive.component.scss"],
})
export class ArchiveComponent implements OnInit {
  isArchive: boolean = false;

  constructor() {}

  ngOnInit() {
    const currProvider = JSON.parse(
      sessionStorage.getItem(
        new ProjectConstants().SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED
      )
    );
    if (currProvider.cod === "IBM" || currProvider.cod.includes("KYN")) {
      this.isArchive = true;
    }
  }
}